import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Urls from './utils/urls';
import { globalConfig, globalConfigUrl } from "./config/config";
import axios, { AxiosResponse } from 'axios';
import { prefixPath } from './utils/helpers';
import BaseUrls from './utils/baseUrls';
import Username from './css/usernameStyle';
import CustomStyle from './css/customStyle';
import TokenManager from '@zeeve-platform/login-utility';
import apiBackendInstance from './utils/axios';
import InAppNotificationsManager from '@zeeve-platform/in-app-notifications-frontend';
import { ToastContainer } from 'react-toastify';
import '@zeeve-platform/in-app-notifications-frontend/dist/esm/css/styles.css'

function setCookie(name: string, value: string, t: number) {
  var expires = "";
  if (t) {
    var date = new Date();
    date.setTime(date.getTime() + (t * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

const loaderChanger = () => {
  const bodyTag: any = document.getElementById('imgLoad');
  let theme = '';
  if (globalConfig.config) {
    theme = BaseUrls.getkey();
  }

  if (bodyTag) {
    const headerLogoUrl = window.location.origin + prefixPath(`/img/${theme}/Mainloader.svg`);
    bodyTag.src = headerLogoUrl;
  }
}


const setUserNameStyle = () => {
  let userNameStyle = '';
  let theme = '';
  if (globalConfig.config) {
    const Customtheme = BaseUrls.getkey();
    theme = Customtheme;
  }
  document.title = theme;
  switch (theme) {
    case 'zeeve':
      userNameStyle = Username.usernameZeeveStyle();
      break;
    case 'helious':
      userNameStyle = Username.usernameHeliosStyle();
      break;
    case 'phaeton':
      userNameStyle = Username.usernameHeliosStyle();
      break;
    default:
      break;
  }
  return userNameStyle;
};
const setCustomStyle = () => {
  let customStyle = '';
  let theme = '';
  if (globalConfig.config) {
    const Customtheme = BaseUrls.getkey();
    theme = Customtheme;
  }
  switch (theme) {
    case 'zeeve':
      customStyle = CustomStyle.customZeeveStyle();
      break;
    case 'helious':
      customStyle = CustomStyle.customHeliosStyle();
      break;
    case 'phaeton':
      customStyle = CustomStyle.customHeliosStyle();
      break;
    default:
      break;
  }
  return customStyle;
};

// axios.get("/" + globalConfigUrl)

axios.get(prefixPath('/' + globalConfigUrl))
  .then((response) => {
    globalConfig.config = response.data;
    loaderChanger();
    var link: HTMLAnchorElement | null = document.querySelector("link[rel~='icon']");
    if (link) {
      const theme = BaseUrls.getkey();
      link.href = `img/${theme}/favicon.ico`;
    }

  })
  .then(() => {
    if (Urls.getBackendUrl() === undefined || Urls.getBackendUrl() === null) {

      throw new Error("error with config file")

    }
  }).
  then(() => {
    // initialising token manager 
    return TokenManager.createInstance(
      BaseUrls.getAuthUrl(),
      apiBackendInstance,
    );
  }).
  then(() => new Promise((resolve) => {
    const token = TokenManager.getInstance().getAccessToken();
    InAppNotificationsManager.createInstance(BaseUrls.getInappNotificationsUrl(token), {
      InaApp: {},
    });
    TokenManager.getInstance().updateCallbacks({
      accessTokenRotationCallbacks: {
        onAccessTokenUpdate: (access_token) => {
          // update notifications manager ws address with newer token whenever a token is rotated
          InAppNotificationsManager.getInstance().updateWsAddress(BaseUrls.getInappNotificationsUrl(access_token));
        }
      }
    });
    resolve('ok');
  })).
  then(() => {

    ReactDOM.render(
      <React.StrictMode>
        <AuthContext.Provider value={{ access_token: getAccessToken(), refresh_token: getRefreshToken() }} >
          <BrowserRouter>
            <style>{setCustomStyle()}</style>
            <style>{setUserNameStyle()}</style>
            <ToastContainer />
            <App />
          </BrowserRouter>
        </AuthContext.Provider >
      </React.StrictMode>,
      document.getElementById('root'),
    );
  })
  .catch(() => {
    console.error("config file missing")

    throw 400

  })

  ;

function getAccessToken(): string {
  try {
    let access_token = document.cookie.split(';')[0].split('=')[1]
    return access_token;
  }
  catch (error) {
    return '';
  }
}

function getRefreshToken(): string {
  try {
    let refresh_token = document.cookie.split(';')[1].split('=')[1]
    return refresh_token;
  }
  catch (error) {
    return '';
  }
}

const AuthContext = React.createContext({
  access_token: '',
  refresh_token: ''
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
